export default [
  {
    path: '/dashboard-cambio',
    name: 'dashboardCambio',
    redirect: { name: 'dashboardSatya', query: { aba: 'cambio' } }
  }
];
